<template>
  <span class="predicted-coding-icon" v-tooltip="'Predicted coding'" aria-label="Predicted coding">
    <svg viewBox="0 0 16 16" focusable="false" aria-hidden="true">
      <path d="M9.1 0.7L2.7 8.5h4.5l-0.3 6.8 6.4-8.6H8.8L9.1 0.7z" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'PredictedCodingIcon'
}
</script>

<style lang="scss" scoped>
.predicted-coding-icon {
  color: #1890FF;
  cursor: default;
  display: inline-flex;
  height: 16px;
  line-height: 16px;
  pointer-events: auto;
  width: 16px;

  svg {
    display: block;
    fill: currentColor;
    height: 16px;
    width: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/PredictedCodingIcon.vue